import React, { useCallback, useEffect, useContext, useState } from "react";
import { FormikContext } from "formik";
import PropTypes from "prop-types";
import { ResultadoDeSorteiosForm } from "../../../../forms";
import { useResultadoSorteios } from "../../../../hooks";
import ResultadoImg from "../../../../assets/images/residencial/ilustracao-homem-comemorando-sorteio.svg";
import { SectionContent, Loading } from "../../../../components";
import { parseISO } from "../../../../utils/dateUtils";
import ResultadoSorteiosEmprestimos from "../../../../components/ResultadoSorteiosEmprestimos";

const FormConsulta = ({ resultados, dataSorteios, products }) => {
  const { setFieldValue } = useContext(FormikContext);
  const [anoResultado, setAnoResultado] = useState("");

  useEffect(() => {
    setFieldValue("produto", products[0], true);
  }, [products, setFieldValue]);

  useEffect(() => {
    if (resultados?.data_extracao) {
      const dataExtracao = parseISO(resultados.data_extracao);
      setAnoResultado(dataExtracao.getFullYear());
    }
  }, [resultados]);

  return (
    <>
      <ResultadoSorteiosEmprestimos
        resultados={resultados}
        dataSorteios={dataSorteios}
        anoResultado={anoResultado}
        imgSrc={ResultadoImg}
        imgAlt="Homem comemorando resultado de sorteio"
        setAnoResultado={setAnoResultado}
      />
    </>
  );
};
FormConsulta.propTypes = {
  resultados: PropTypes.oneOfType([PropTypes.object]),
  dataSorteios: PropTypes.arrayOf(PropTypes.string),
  products: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

FormConsulta.defaultProps = {
  resultados: null,
  dataSorteios: [],
};

const ConsultaDeSorteios = () => {
  const {
    setBusca,
    resultados,
    dataSorteios,
    loading,
  } = useResultadoSorteios();
  const buscarResultadoHandle = useCallback(
    ({ titulo, produto, dataBusca }) => {
      setBusca({ plano: produto, dataBusca, titulo });
    },
    [setBusca]
  );

  useEffect(() => {
    if (!resultados && !loading) {
      setBusca({ plano: { value: "818", label: "RESIDENCIAL FACIL" } });
    }
  }, [loading, resultados, setBusca]);

  return (
    <Loading loading={loading}>
      <SectionContent>
        <ResultadoDeSorteiosForm
          form={FormConsulta}
          buscarResultado={buscarResultadoHandle}
          resultados={resultados}
          dataSorteios={dataSorteios}
          onResetForm={() =>
            setBusca({ plano: null, titulo: "", dataBusca: "" })
          }
          products={[{ value: 818, label: "RESIDENCIAL FACIL" }]}
        />
      </SectionContent>
    </Loading>
  );
};
ConsultaDeSorteios.propTypes = {};
export default ConsultaDeSorteios;
